var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_Icons/Map/Car Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCCF_Circulation-Rules",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circulation-Rules_-Porto",
    transform: "translate(-48.000000, -1248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(46.000000, 1244.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,19.9999992 L5,19.9999992 L5,20.9999992 C5,21.5522847 4.55228475,21.9999992 4,21.9999992 L3,21.9999992 C2.44771525,21.9999992 2,21.5522847 2,20.9999992 L2,10.9999992 L4.48,5.212 C4.79545147,4.47612415 5.51936126,3.99928792 6.32,3.9999992 L17.68,3.9999992 C18.4799122,3.9999992 19.2028346,4.47679238 19.518,5.212 L22,10.9999992 L22,20.9999992 C22,21.5522847 21.5522847,21.9999992 21,21.9999992 L20,21.9999992 C19.4477153,21.9999992 19,21.5522847 19,20.9999992 L19,19.9999992 Z M20,13 L4,13 L4,18 L20,18 L20,13 Z M4.176,11 L19.824,11 L17.681,6 L6.32,6 L4.177,11 L4.176,11 Z M6.5,17 C5.67157288,17 5,16.3284271 5,15.5 C5,14.6715729 5.67157288,14 6.5,14 C7.32842712,14 8,14.6715729 8,15.5 C8,16.3284271 7.32842712,17 6.5,17 Z M17.5,17 C16.6715729,17 16,16.3284271 16,15.5 C16,14.6715729 16.6715729,14 17.5,14 C18.3284271,14 19,14.6715729 19,15.5 C19,16.3284271 18.3284271,17 17.5,17 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.727de894bee14400cfb01be4ace2c289.svg";
export { ForwardRef as ReactComponent };